
import React from 'react';
import { ShieldCheckIcon, ExclamationTriangleIcon } from '../assets/icons';

const MOCK_DOCUMENTS = [
    { id: 1, user: 'Ana Souza', doc: 'Foto CNH', status: 'warning', aiConfidence: 45, issue: 'Baixa resolução' },
    { id: 2, user: 'Marcos Silva', doc: 'Comprovante Residência', status: 'danger', aiConfidence: 12, issue: 'Data antiga (>90 dias)' },
    { id: 3, user: 'Pedro Santos', doc: 'Certificado CR', status: 'success', aiConfidence: 98, issue: 'Nenhum' },
    { id: 4, user: 'João Kleber', doc: 'Laudo Psicológico', status: 'warning', aiConfidence: 60, issue: 'Assinatura ilegível?' },
];

const AdminCompliance: React.FC = () => {
    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-bold text-white uppercase tracking-wider flex items-center gap-2">
                    <ShieldCheckIcon className="h-6 w-6 text-green-500" />
                    Escudo (Compliance Queue)
                </h2>
                <div className="bg-gray-800 px-4 py-2 rounded-lg text-xs font-mono text-gray-400 border border-gray-700">
                    IA Compliance Bot: <span className="text-green-400 font-bold">ONLINE</span>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {MOCK_DOCUMENTS.map((doc) => (
                    <div key={doc.id} className="bg-gray-800/40 border border-gray-700 rounded-xl p-5 hover:border-arsenal-red transition-all group backdrop-blur-sm">
                        <div className="flex justify-between items-start">
                            <div>
                                <h3 className="font-bold text-white">{doc.user}</h3>
                                <p className="text-sm text-gray-400">{doc.doc}</p>
                            </div>
                            <div className={`px-2 py-1 rounded text-xs font-bold uppercase ${doc.status === 'success' ? 'bg-green-500/20 text-green-400' :
                                doc.status === 'warning' ? 'bg-amber-500/20 text-amber-400' :
                                    'bg-red-500/20 text-red-400'
                                }`}>
                                {doc.aiConfidence}% Confiança
                            </div>
                        </div>

                        {doc.status !== 'success' && (
                            <div className="mt-4 bg-black/30 p-3 rounded border border-gray-700 flex items-start gap-2">
                                <ExclamationTriangleIcon className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" />
                                <div>
                                    <p className="text-xs text-gray-300 font-bold mb-1">Análise da IA:</p>
                                    <p className="text-xs text-gray-500">{doc.issue}</p>
                                </div>
                            </div>
                        )}

                        <div className="mt-4 flex gap-2">
                            <button className="flex-1 bg-green-600/20 hover:bg-green-600/40 text-green-400 border border-green-600/50 py-2 rounded-lg text-xs font-bold uppercase transition-colors">
                                Aprovar
                            </button>
                            <button className="flex-1 bg-red-600/20 hover:bg-red-600/40 text-red-400 border border-red-600/50 py-2 rounded-lg text-xs font-bold uppercase transition-colors">
                                Rejeitar
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminCompliance;
